import { EmailIcon } from '@chakra-ui/icons';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Box,
  Tooltip,
} from '@chakra-ui/react';
import axios from 'axios';
import FormikFormControl from 'components/common/forms/FormikFormControl';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { userBaseColumns } from 'utils/columns/userColumns';
import SelectGroupInput from 'components/common/forms/SelectGroupInput';
import UserTable from '../UserTable';

function SearchGroupMd({ handleAdd }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [group, setGroup] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleOnSelectRow = (rows) => {
    setSelectedUsers(rows);
  };

  useEffect(() => {
    if (group) {
      axios
        .get(`/graph/groups/${group}/members`)
        .then((response) => {
          setUsers(
            response.data?.map((item) => ({
              label: item.name,
              value: item.email,
            }))
          );
        })
        .catch(() => {
          setUsers([]);
        });
    }
  }, [group]);

  useEffect(() => {
    if (!isOpen) {
      setGroup(null);
      setUsers([]);
      setSelectedUsers([]);
    }
  }, [isOpen]);

  return (
    <>
      <Button onClick={onOpen} leftIcon={<EmailIcon />} colorScheme="teal">
        SEARCH VIA DL
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>SEARCH VIA DL</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box minH={500}>
              <FormikFormControl
                label="Select Group"
                helperText="This feature supports up to 900 users from the selected distribution list and does not include nested distribution lists."
              >
                <SelectGroupInput onChangeHandler={setGroup} />
              </FormikFormControl>

              <UserTable
                users={users}
                columns={userBaseColumns}
                onSelectRowHandler={handleOnSelectRow}
              />
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={onClose} mr={3}>
              Close
            </Button>

            <Tooltip
              label={selectedUsers.length === 0 ? 'Select user first' : ''}
            >
              <Button
                colorScheme="red"
                isDisabled={selectedUsers.length === 0}
                px={10}
                onClick={() => {
                  handleAdd(users);
                  onClose();
                }}
              >
                Add
              </Button>
            </Tooltip>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

SearchGroupMd.propTypes = {
  handleAdd: PropTypes.func.isRequired,
};

export default SearchGroupMd;
